import { CarvanaTheme } from '@carvana/showroom-theme';

const { light, dark, special } = CarvanaTheme;
const Theme = {
  carvana: {
    body: '#e4ecf0',
    blue: {
      primary: '#00aed9',
      hover: '#018dc0',
      medium: '#00619e', // sticky header bg
      dark: '#183558', // headlines and footer
      pastel: '#cfeaf2', // accent
      dropdown: '#08689a',
      light: '#00AED9'
    },
    gray: {
      background: '#f4f8fa',
      light: '#d9dde9', // secondary copy, tabs and field outlines, lines
      medium: '#aab1c7', // unselected Icons, favorites heart and other things
      dark: '#757989' // text and icons
    },
    green: {
      primary: '#1dd08b',
      apple: '#78be20'
    }, // success green
    red: {
      primary: '#ff7171'
    }, // alert red, faved
    white: {
      primary: '#ffffff',
      light: '#f3f3f3'
    },
    black: {
      primary: '#000000'
    },
    yellow: {
      primary: '#feb948',
      hover: '#eb9f23',
      pastel: '#fbf2de',
      warning: '#FFF5E4'
    },
    stroke: {
      blue: '#122946' // divider line color in footer
    },
    impersonationRed: '#ff0000'
  },
  social: { facebook: { blue: '#3b5998' } },
  header: {
    stroke: '#045489',
    background: '#00619e',
    boxShadow: 'rgba(25, 41, 61, 0.13)',
    border: '#eef3f4', // border color in comparison tool
    transparency: {
      hidden: 'rgba(0,0,0,0)',
      partial: 'rgba(0,0,0,0.7)'
    }
  },
  typography: {
    fontFamily: '"Brandon Text", "Lato", sans-serif;',
    fontSize: 16
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 960,
      lg: 1280,
      xl: 1800
    }
  },
  light,
  dark,
  special
};

export default Theme;
